import { render, staticRenderFns } from "./CoreFiguresHeader.vue?vue&type=template&id=26434447&"
import script from "./CoreFiguresHeader.vue?vue&type=script&lang=js&"
export * from "./CoreFiguresHeader.vue?vue&type=script&lang=js&"
import style0 from "./CoreFiguresHeader.vue?vue&type=style&index=0&id=26434447&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports